// extracted by mini-css-extract-plugin
export default {"addReports":"service_addReports__c2IsZ","addButtuon":"service_addButtuon__-ulkT","serviceName":"service_serviceName__yhlT6"};